import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { DriverProfileWizardFullscreen } from '../../components/DriverProfileWizardFullscreen';
import { BasicDriverInfoStep } from '../../components/wizard-steps/BasicDriverInfoStep';
import { DetailedDriverLicenseStep } from '../../components/wizard-steps/DetailedDriverLicenseStep';
import { DetailedEducationStep } from '../../components/wizard-steps/DetailedEducationStep';
import { DrivingExperienceStep } from '../../components/wizard-steps/DrivingExperienceStep';
import { DetailedCertificationStep } from '../../components/wizard-steps/DetailedCertificationStep';

export const DriverWizard: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Check if editing existing driver
  const driverId = searchParams.get('driverId')
    ? parseInt(searchParams.get('driverId')!, 10)
    : undefined;

  const steps = [
    {
      id: 'driver',
      title: 'Driver Profile',
      component: BasicDriverInfoStep,
    },
    {
      id: 'license',
      title: 'Driving Licenses',
      component: DetailedDriverLicenseStep,
    },
    {
      id: 'education',
      title: 'Education',
      component: DetailedEducationStep,
    },
    {
      id: 'employment',
      title: 'Employment',
      component: DrivingExperienceStep,
    },
    {
      id: 'certification',
      title: 'Certifications',
      component: DetailedCertificationStep,
    },
  ];

  const handleComplete = () => {
    // Navigate back to drivers list or show success message
    navigate('/drivers');
  };

  return (
    <DriverProfileWizardFullscreen steps={steps} onComplete={handleComplete} driverId={driverId} />
  );
};
